/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Card from "components/card";
import React, { useState } from "react";
import dataService from "service/dataService";
import ReactDatePicker from 'react-datepicker';
import InvoiceGenerator from './InvoiceGenerator';
import {
  MdOutlineCalendarMonth,

} from "react-icons/md";


const Invoice = () => {
  // Fetch unique student names for the dropdown
  const [uniqueNames, setUniqueNames] = React.useState<string[]>([]);
  const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), 1));

  React.useEffect(() => {
    const fetchUniqueNames = async () => {
      const names = await dataService.getUniqueFullNames('dailyHours');
      setUniqueNames(names);
    };
    console.log('Unique names in Invoice component:', startDate);
    fetchUniqueNames();
  }, []);

 const getMonthName = (date:any) => {
    return date.toLocaleString('en-US', { month: 'long' }); // 'long' for full name, 'short' for abbreviated
  };

  const handleMonthChange = (startDate:Date, index:any) => {
    setStartDate(startDate);
    console.log('Selected month:', startDate +"idx"+index);
  }
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState<any>(null);
  function handleRedirect(name: string, startDate: Date, index:number): void {
   // window.location.href = `#/rtl/default/invoice-details/${name}/${startDate.getMonth() + 1}/${startDate.getFullYear()}`;
    setModalData({ name, startDate: startDate.toISOString().split('T')[0], month: startDate.getMonth() + 1, year: startDate.getFullYear(), index });
    setIsModalOpen(true);
  }
 
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalData(null); // Clear data on close
  };

  return (
    <div>
      <Card extra="pb-7 p-[20px]">
       {/* task header */}
   <div className="overflow-x-auto">
    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
            <tr>
                <th scope="col" className="px-6 py-3">
                   #
                </th>
                <th scope="col" className="px-6 py-3">
                    Student Name
                </th>
                <th scope="col" className="px-6 py-3">
                    Month
                </th>
                <th scope="col" className="px-6 py-3">
                    <span className="sr-only">Invoice</span>
                </th>
            </tr>
        </thead>
        <tbody>
      
            {uniqueNames.map((name, index) => (
              <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600">
               <th scope="row" className="px-6 py-4 font-medium text-gray-400 whitespace-nowrap dark:text-white">
                 {index + 1}
               </th>
               <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {name}
               </td>
               <td>
                <ReactDatePicker
                   //selected={startDate}
                   placeholderText={getMonthName(startDate)}
                   dateFormat="MM/yyyy" // Format to display month and year
                   showMonthYearPicker // Enable month and year picker
                   onChange={(startDate: Date | null) => handleMonthChange(startDate, index)}
                   
                   customInput={
                     <div style={{ display: 'flex', alignItems: 'center'   }}>
                        <MdOutlineCalendarMonth 
                         style={{
                           position: 'absolute',
                           left: '8px',
                           cursor: 'pointer',
                         }}
                         onClick={() => {
                           // You might need to programmatically open the date picker here
                           // depending on the date picker library's API
                         }}
                       />
                       <input
                         type="text"
                         id={index.toLocaleString()}
                         value={startDate ? getMonthName(startDate) : ''}
                         readOnly // Make the input read-only to prevent manual typing
                         style={{ paddingLeft: '30px', width: '100%' }} // Add padding for the icon and set width
                         className="w-34 h-8 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      />
        
                     </div>
                   }

                   />
                </td>
                {/* Invoice View Link   href={`#/rtl/default/invoice-details/${name}/${startDate.getMonth() + 1}/${startDate.getFullYear()}`}*/}
                <td className="px-6 py-4 text-right">  
                <a  href='#' onClick={() => handleRedirect(name, startDate, index)} className="inline-flex items-center text-blue-500 hover:text-blue-700 font-medium">
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                 View Invoice
                </a>

               </td>
             </tr>
            ))}
        </tbody>
    </table>
     <InvoiceGenerator 
        isOpen={isModalOpen} 
        onClose={handleCloseModal} 
        title="Invoice Details" 
        data={modalData} // Pass the data to the modal
       >
        <span> {modalData ? modalData.name : ''}</span>
    </InvoiceGenerator>
 </div>

     </Card>
   </div>
  );
};

export default Invoice;
